export var SET_DISPLAY_MODE = 'SET_DISPLAY_MODE';



// WEBPACK FOOTER //
// ./src/actions/displayMode.js